import React from 'react'
import './Footer.css'
import Insta from '@iconscout/react-unicons/icons/uil-instagram'
import  Linkedin from '@iconscout/react-unicons/icons/uil-linkedin'
import Github from '@iconscout/react-unicons/icons/uil-github'
import Facebook from '@iconscout/react-unicons/icons/uil-facebook'
import Wave from '../../img/wave.png'

// yarn add @iconscout/react-unicons
// After set Dark Mode We set Animation yarn add framer-motion
const Footer = () => {
  return (
    <div className="footer" id="Footer">
      <img src={Wave} alt="" style={{width: '100%'}} />
      <div className="f-content">
        <span>ravitandan800@gmail.com</span>
        <div className="f-icons">
          <a href="https://github.com/RaviTandan"><Github color='white' size='3rem'/></a>
          <a href="https://www.linkedin.com/in/ravi-tandan-219090250"><Linkedin color='white' size='3rem'/></a>
          <a href="https://www.instagram.com/invites/contact/?i=1vlkm67667jey&utm_content=ibj3jb7"><Insta color='white' size='3rem'/></a>
          <a href="https://www.facebook.com/ravi.tandan.528"><Facebook color='white' size='3rem'/></a>
        </div>
      </div>
    </div>
  )
}

export default Footer
